import { Sparkles } from 'lucide-react';
import { Badge } from '@/components/ui';
import type { Agent } from '../types';

interface AgentCardProps {
  agent: Agent;
  onSelect: (agentId: string) => void;
  disabled?: boolean;
  /** Owning space name, shown as a badge to disambiguate the same agent
   *  installed across multiple spaces. Omitted for platform agents. */
  spaceLabel?: string;
}

export function AgentCard({ agent, onSelect, disabled, spaceLabel }: AgentCardProps) {
  return (
    <button
      type="button"
      onClick={() => onSelect(agent.agentId)}
      disabled={disabled}
      className="text-left rounded-xl border border-border bg-card p-6 flex flex-col gap-3 transition-colors hover:border-primary-500 hover:bg-accent/30 disabled:opacity-60 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
    >
      <div className="flex items-center gap-3">
        <Sparkles className="h-5 w-5 shrink-0 text-muted-foreground" />
        <h3 className="text-lg font-semibold text-foreground truncate">
          {agent.name}
        </h3>
        {spaceLabel && (
          <Badge variant="gray" className="ml-auto shrink-0 whitespace-nowrap">
            {spaceLabel}
          </Badge>
        )}
      </div>
      <p className="text-sm text-muted-foreground line-clamp-3">
        {agent.description?.trim() || agent.name}
      </p>
    </button>
  );
}
